$shm_ba_date $shm_period
	period_all *
		from \0001-01-01
		to \2999-12-31
	Date_from $shm_date_view
		value? <=> date_from? \
		value_min <= date_min \
		value_max <= date_max \
		bubble_content /
			<= Date_from_bubble $mol_view
				sub <= date_from_picker_content /
	Date_from_calendar_column $mol_view
		sub <= date_from_calendar_content /
	Date_to $shm_date_view
		value? <=> date_to? \
		value_min <= date_min \
		value_max <= date_max \
		bubble_content /
			<= Date_to_bubble $mol_view
				sub <= date_to_picker_content /
	Date_to_calendar_column $mol_view
		sub <= date_to_calendar_content /
	Presets_list $mol_list
		rows <= preset_rows /
	Preset* $mol_button_minor
		title <= option_label* \
		click? <=> preset_pick*? null
